import { render, staticRenderFns } from "./KommunalrabattIcon.vue?vue&type=template&id=10800114&scoped=true&"
import script from "./KommunalrabattIcon.vue?vue&type=script&lang=js&"
export * from "./KommunalrabattIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10800114",
  null
  
)

export default component.exports